/* eslint-disable */
import axios from 'axios';
import types from '../../types';
import { getLastActivity } from './activity';


let refreshTimer = null
const IDLE_TIMEOUT_MS = 60 * 60 * 1000 // 60 minutes — idle logout threshold

export default {
  [types.SHOW_APP_VIEWS]: ({ commit }, payload) => {
    commit('SHOW_APP_VIEWS', payload);
  },
  [types.LOGIN]: async ({ commit }, payload) => {
    try {
      return await axios.post('/authenticate/login', {...payload}).then((res) => {
        return res.data.data;
      })
    } catch (e) {
      throw e;
    }
  },
  [types.FORGOT_PASSWORD]: async ({ commit }, payload) => {
    try {
      let response = await axios.post('/authenticate/forgot-password', {...payload});
      return response.data.data;
    } catch (e) {
      throw e;
    }
  },
  [types.RESET_PASSWORD]: async ({ commit }, payload) => {
    try {
      let response = await axios.post('/authenticate/reset-password', {...payload});
      return response.data.data;
    } catch (e) {
      throw e;
    }
  },
  [types.LOGOUT]: async ({ commit }, payload = {}) => {
    if (refreshTimer) { clearTimeout(refreshTimer); refreshTimer = null }
    const reason = payload?.reason ?? 'explicit'
    try {
      if (axios.defaults.headers.common.Authorization) {
        await axios.post('authenticate/logout', { reason }, { withCredentials: true })
      }
    } catch (e) {
      // continue with client-side logout even if API call fails
    }
    delete axios.defaults.headers.common.Authorization
    commit('LOGOUT')
    commit('SET_FORCE_REDIRECT', '/login')
  },
  [types.GET_PROFILE]: async ({ commit }) => {
    try {
      return await axios.get('/profile').then((res) => {
        return res.data.data;
      });
    } catch (e) {
      throw new Error(e);
    }
  },
  [types.TEST_TOKEN]: async ({ commit }) => {
    try {
      return await axios.get('/profile').then((res) => {
        return 200;
      });
    } catch (e) {
      return e?.response?.status;
    }
  },
  [types.BOOTSTRAP_AUTH]: async ({ commit, dispatch, rootState }) => {
    try {
      const resp = await axios.post('refresh-token', {}, { withCredentials: true })
      const token = resp?.data?.data?.token

      if (token) {
        dispatch('STORE_TOKEN', token)

        try {
          const profile = await dispatch('GET_PROFILE')

          dispatch('STORE_USER', profile)

          await dispatch('GET_MY_PERMISSIONS')

          const subaccounts = await dispatch('GET_SUBACCOUNTS')

          const active = profile.active_subaccount_id != null
            ? subaccounts.filter(s => s.id == profile.active_subaccount_id)[0]
            : subaccounts.filter(s => s.is_main == 1)[0]
          dispatch('STORE_ACTIVE_SUBACCOUNT', active)

          dispatch('LOGIN_USER_FLAG', true)
        } catch (profileErr) {
          console.error('[BOOTSTRAP_AUTH] State restoration failed after token set:', profileErr?.message || profileErr)
          commit('LOGOUT')
        }
      }
    } catch (e) {
    } finally {
      commit('SET_BOOTSTRAP_COMPLETE')
    }
  },
  [types.REFRESH_TOKEN]: async ({ commit, dispatch }) => {
    try {
      const resp = await axios.post(
        'refresh-token',
        {},
        { withCredentials: true }
      )
      const token = resp?.data?.data?.token
      if (token) {
        dispatch('STORE_TOKEN', token)
      }
      return token
    } catch (e) {
      commit('LOGOUT')
      commit('SET_FORCE_REDIRECT', '/login')
      return null
    }
  },
  [types.LOGIN_USER_FLAG]: ({ commit }, payload) => {
    commit('LOGIN_USER_FLAG', payload);
  },
  [types.STORE_USER]: ({ commit }, payload) => {
    localStorage.setItem('lang', payload.language);
    localStorage.setItem('timezone', payload.timezone);
    localStorage.setItem('time_format', payload.time_format);
    localStorage.setItem('date_format', payload.date_format);
    commit('STORE_USER', payload);
  },
  [types.STORE_TOKEN]: ({ commit, dispatch }, payload) => {
    if (refreshTimer) { clearTimeout(refreshTimer); refreshTimer = null }
    commit('STORE_TOKEN', payload);
    axios.defaults.headers.common = {
      Authorization: `Bearer ${payload}`,
    };
    try {
      const exp = JSON.parse(atob(payload.split('.')[1])).exp
      const delay = (exp * 1000) - Date.now() - (2 * 60 * 1000)
      if (delay > 0) {
        refreshTimer = setTimeout(() => {
          const idleTime = Date.now() - getLastActivity()
          if (idleTime > IDLE_TIMEOUT_MS) {
            dispatch('LOGOUT', { reason: 'idle' })
          } else {
            dispatch('REFRESH_TOKEN')
          }
        }, delay)
      } else {
        console.warn('[STORE_TOKEN] Delay <= 0 — timer NOT set ⚠️', { delay })
      }
    } catch (e) {
      console.error('[STORE_TOKEN] Failed to decode token', e)
    }
  },
  [types.GET_SUBACCOUNTS]: async ({ commit }) => {
    try {
      return await axios.get('/subaccount').then((res) => {
        commit('STORE_SUBACCOUNTS', res.data.data);
        return res.data.data;
      });
    } catch (e) {
      throw new Error(e);
    }
  },
  [types.STORE_ACTIVE_SUBACCOUNT]: ({ commit }, payload) => {
    commit('STORE_ACTIVE_SUBACCOUNT', payload);
  },
};
